import { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { DeliveryListParams } from '../api/webhooks-api';
import { DELIVERY_FILTER_FIELDS, DELIVERY_SORTS } from '../components/delivery-filters';

/** URL search params of an endpoint's delivery log; mirrors GET .../webhooks/{id}/deliveries. */
export const deliveryListSearchSchema = indexSearchSchema(DELIVERY_FILTER_FIELDS, {
  sort: DELIVERY_SORTS,
})
  // No text search on this endpoint. The router keeps a param the schema leaves out, so `q` is
  // read and thrown away instead.
  .extend({ q: z.undefined().catch(undefined) });

export type DeliveryListSearch = z.infer<typeof deliveryListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function deliveryListParams(search: DeliveryListSearch): DeliveryListParams {
  return listParams(search, DELIVERY_FILTER_FIELDS);
}
